import { ChangeDetectorRef, EventEmitter, SimpleChanges, } from '@angular/core';
import { FundChartService } from 'ChartApp/ts/services/fund-chart.service';
import * as i0 from "@angular/core";
import * as i1 from "ChartApp/ts/services/fund-chart.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
function PresentationChartComponent_ycn_loading_symbol_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 2);
} }
function PresentationChartComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "span");
    i0.ɵɵtext(2, "To get started,");
    i0.ɵɵelement(3, "br");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5, "add items from the left sidebar.");
    i0.ɵɵelementEnd()();
} }
function PresentationChartComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "img", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r0.embedUrl, i0.ɵɵsanitizeUrl);
} }
function PresentationChartComponent_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.errorText);
} }
function PresentationChartComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, PresentationChartComponent_div_1_div_1_Template, 6, 0, "div", 3)(2, PresentationChartComponent_div_1_div_2_Template, 2, 1, "div", 1)(3, PresentationChartComponent_div_1_div_3_Template, 3, 1, "div", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.errorText && !ctx_r0.imageUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.errorText && ctx_r0.imageUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.errorText);
} }
export class PresentationChartComponent {
    constructor(fundChartService, changeDetector) {
        this.fundChartService = fundChartService;
        this.changeDetector = changeDetector;
        this.loading = false;
        this.errorText = '';
        this.embedUrl = '';
        this.Image = window.Image;
        this.chartDataHandler = new EventEmitter();
        this.DEFAULT_ERROR_TEXT = 'An error has occurred generating the chart image. Please reload the page.';
        this.fetchSubscription = null;
    }
    ngOnChanges(changeObj) {
        // Remove any error text as we check for changes.
        this.errorText = null;
        if (changeObj.imageUrl?.currentValue) {
            if (changeObj.imageUrl?.currentValue !== changeObj.imageUrl?.previousValue &&
                this.fetchSubscription !== null) {
                this.fetchSubscription.unsubscribe();
            }
            this.loading = true;
            this.imageLoader(changeObj.imageUrl.currentValue);
            this.getChartData();
        }
    }
    ngOnDestroy() {
        if (this.fetchSubscription !== null) {
            this.fetchSubscription.unsubscribe();
        }
    }
    getChartData() {
        const request = this.chartDataUrl
            ? this.fundChartService.getChartDataFromUrl(this.chartDataUrl, this.isFundChartCreator)
            : this.fundChartService.getChartDataFromState(this.chartFormData, this.isFundChartCreator);
        this.fetchSubscription = request.subscribe({
            next: (chartData) => {
                this.chartDataHandler.emit(chartData);
            },
            error: (error) => {
                switch (error.status) {
                    case 400:
                        // Fund chart data view threw an exception
                        this.errorText = error.error.error;
                        break;
                    default:
                        // Any other error is not expected and we show a generic error message.
                        this.errorText = this.DEFAULT_ERROR_TEXT;
                        break;
                }
            },
        });
    }
    imageLoader(src) {
        const prevImage = new this.Image();
        // Set image onload callback.
        prevImage.onload = () => {
            this.loading = false;
            // onload and onError are outside angular context so need to call apply.
            this.changeDetector.detectChanges();
        };
        // In case of an error, we do not want loader to cycle endlessly
        prevImage.onerror = () => {
            this.loading = false;
            this.changeDetector.detectChanges();
        };
        this.embedUrl = src;
        prevImage.src = src;
    }
}
PresentationChartComponent.ɵfac = function PresentationChartComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PresentationChartComponent)(i0.ɵɵdirectiveInject(i1.FundChartService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
PresentationChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PresentationChartComponent, selectors: [["ycn-presentation-chart"]], inputs: { imageUrl: "imageUrl", chartFormData: "chartFormData", chartDataUrl: "chartDataUrl", isFundChartCreator: "isFundChartCreator" }, outputs: { chartDataHandler: "chartDataHandler" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [["loaderMessage", "Loading Chart...", 4, "ngIf"], [4, "ngIf"], ["loaderMessage", "Loading Chart..."], ["class", "chart-canvas get-started", 4, "ngIf"], [1, "chart-canvas", "get-started"], [1, "chart-preview", 3, "src"]], template: function PresentationChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PresentationChartComponent_ycn_loading_symbol_0_Template, 1, 0, "ycn-loading-symbol", 0)(1, PresentationChartComponent_div_1_Template, 4, 3, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading);
    } }, dependencies: [i2.NgIf, i3.LoadingSymbolComponent], encapsulation: 2 });
